'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.errorRange = exports.errorPage = exports.error = exports.loadingRange = exports.loadingPage = exports.loading = exports.expireRange = exports.expirePage = exports.expireAll = exports.expire = exports.removeRange = exports.removePage = exports.remove = exports.addRange = exports.addPage = exports.add = exports.options = exports.ids = exports.range = exports.pageCount = exports.page = exports.resources = exports.resource = exports.shouldFetchRange = exports.shouldFetchPage = exports.shouldFetch = exports.isViewable = exports.isPending = exports.isMissing = exports.isExpired = exports.isLoading = exports.isError = exports.isOK = exports.attach = undefined;

var _attach2 = require('./attach');

var _attach3 = _interopRequireDefault(_attach2);

var _isOk = require('./status/is-ok');

var _isOk2 = _interopRequireDefault(_isOk);

var _isError2 = require('./status/is-error');

var _isError3 = _interopRequireDefault(_isError2);

var _isLoading2 = require('./status/is-loading');

var _isLoading3 = _interopRequireDefault(_isLoading2);

var _isExpired2 = require('./status/is-expired');

var _isExpired3 = _interopRequireDefault(_isExpired2);

var _isMissing2 = require('./status/is-missing');

var _isMissing3 = _interopRequireDefault(_isMissing2);

var _isPending2 = require('./status/is-pending');

var _isPending3 = _interopRequireDefault(_isPending2);

var _isViewable2 = require('./status/is-viewable');

var _isViewable3 = _interopRequireDefault(_isViewable2);

var _shouldFetch2 = require('./resource/should-fetch');

var _shouldFetch3 = _interopRequireDefault(_shouldFetch2);

var _shouldFetchPage2 = require('./list/should-fetch-page');

var _shouldFetchPage3 = _interopRequireDefault(_shouldFetchPage2);

var _shouldFetchRange2 = require('./list/should-fetch-range');

var _shouldFetchRange3 = _interopRequireDefault(_shouldFetchRange2);

var _resource2 = require('./resource');

var _resource3 = _interopRequireDefault(_resource2);

var _list = require('./resource/list');

var _list2 = _interopRequireDefault(_list);

var _page2 = require('./list/page');

var _page3 = _interopRequireDefault(_page2);

var _pageCount2 = require('./list/page-count');

var _pageCount3 = _interopRequireDefault(_pageCount2);

var _range2 = require('./list/range');

var _range3 = _interopRequireDefault(_range2);

var _ids2 = require('./list/ids');

var _ids3 = _interopRequireDefault(_ids2);

var _options2 = require('./list/options');

var _options3 = _interopRequireDefault(_options2);

var _add2 = require('./resource/add');

var _add3 = _interopRequireDefault(_add2);

var _addPage2 = require('./list/add-page');

var _addPage3 = _interopRequireDefault(_addPage2);

var _addRange2 = require('./list/add-range');

var _addRange3 = _interopRequireDefault(_addRange2);

var _remove2 = require('./resource/remove');

var _remove3 = _interopRequireDefault(_remove2);

var _removePage2 = require('./list/remove-page');

var _removePage3 = _interopRequireDefault(_removePage2);

var _removeRange2 = require('./list/remove-range');

var _removeRange3 = _interopRequireDefault(_removeRange2);

var _expire2 = require('./resource/expire');

var _expire3 = _interopRequireDefault(_expire2);

var _expireAll2 = require('./list/expire-all');

var _expireAll3 = _interopRequireDefault(_expireAll2);

var _expirePage2 = require('./list/expire-page');

var _expirePage3 = _interopRequireDefault(_expirePage2);

var _expireRange2 = require('./list/expire-range');

var _expireRange3 = _interopRequireDefault(_expireRange2);

var _loading2 = require('./resource/loading');

var _loading3 = _interopRequireDefault(_loading2);

var _loadingPage2 = require('./list/loading-page');

var _loadingPage3 = _interopRequireDefault(_loadingPage2);

var _loadingRange2 = require('./list/loading-range');

var _loadingRange3 = _interopRequireDefault(_loadingRange2);

var _error2 = require('./resource/error');

var _error3 = _interopRequireDefault(_error2);

var _errorPage2 = require('./list/error-page');

var _errorPage3 = _interopRequireDefault(_errorPage2);

var _errorRange2 = require('./list/error-range');

var _errorRange3 = _interopRequireDefault(_errorRange2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.attach = _attach3.default;

// Status
// Initialization

exports.isOK = _isOk2.default;
exports.isError = _isError3.default;
exports.isLoading = _isLoading3.default;
exports.isExpired = _isExpired3.default;
exports.isMissing = _isMissing3.default;
exports.isPending = _isPending3.default;
exports.isViewable = _isViewable3.default;

// Should fetch

exports.shouldFetch = _shouldFetch3.default;
exports.shouldFetchPage = _shouldFetchPage3.default;
exports.shouldFetchRange = _shouldFetchRange3.default;

// Retrieval

exports.resource = _resource3.default;
exports.resources = _list2.default;
exports.page = _page3.default;
exports.pageCount = _pageCount3.default;
exports.range = _range3.default;
exports.ids = _ids3.default;
exports.options = _options3.default;

// Add / Update

exports.add = _add3.default;
exports.addPage = _addPage3.default;
exports.addRange = _addRange3.default;

// Removal

exports.remove = _remove3.default;
exports.removePage = _removePage3.default;
exports.removeRange = _removeRange3.default;

// Expiry

exports.expire = _expire3.default;
exports.expireAll = _expireAll3.default;
exports.expirePage = _expirePage3.default;
exports.expireRange = _expireRange3.default;

// Loading

exports.loading = _loading3.default;
exports.loadingPage = _loadingPage3.default;
exports.loadingRange = _loadingRange3.default;

// Error

exports.error = _error3.default;
exports.errorPage = _errorPage3.default;
exports.errorRange = _errorRange3.default;